import styled from 'styled-components';
import { Button } from "../Buttons/ButtonV2";

export const Container = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__Container", componentId: "sc-1596n1o-0" })(["display:grid;gap:", ";"],

({ theme }) => theme.spacers.L);


export const Row = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__Row", componentId: "sc-1596n1o-1" })(["display:flex;align-items:center;column-gap:", ";"],


({ theme }) => theme.spacers.M);


export const Title = /*#__PURE__*/styled.h2.withConfig({ displayName: "styles__Title", componentId: "sc-1596n1o-2" })(["", ";color:", ";padding-bottom:", ";padding-right:", ";"],
({ theme }) => theme.typography.SmallHeadline,
({ theme }) => theme.colors.Foreground,
({ theme, thin }) => thin ? '0' : theme.spacers.M,
({ theme }) => theme.spacers.XL);


export const Paragraph = /*#__PURE__*/styled.p.withConfig({ displayName: "styles__Paragraph", componentId: "sc-1596n1o-3" })(["", ";color:", ";"],
({ theme }) => theme.typography.Paragraph,
({ theme }) => theme.colors['Level 5']);


export const EmojiRow = /*#__PURE__*/styled(Row).withConfig({ displayName: "styles__EmojiRow", componentId: "sc-1596n1o-4" })(["justify-content:space-between;"]);



export const LabelRow = /*#__PURE__*/styled(Row).withConfig({ displayName: "styles__LabelRow", componentId: "sc-1596n1o-5" })(["justify-content:space-between;margin-top:", ";"],

({ theme }) => theme.spacers.S);


export const EmojiIcon = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__EmojiIcon", componentId: "sc-1596n1o-6" })(["width:48px;height:48px;cursor:pointer;border-radius:24px;display:flex;align-items:center;justify-content:center;background-color:", ";&:hover{background-color:", ";}"],









({ theme }) => theme.colors['Level 1'],


({ theme }) => theme.colors['Level 2']);



export const TextArea = /*#__PURE__*/styled.textarea.withConfig({ displayName: "styles__TextArea", componentId: "sc-1596n1o-7" })(["", ";width:100%;resize:none;box-sizing:border-box;padding:", ";border-radius:", ";color:", ";background-color:", ";border:1px solid ", ";&:focus{outline:transparent;}"],
({ theme }) => theme.typography.Paragraph,




({ theme }) => theme.spacers.M,
({ theme }) => theme.spacers.S,
({ theme }) => theme.colors['Level 5'],
({ theme }) => theme.colors.ElementBackground,
({ theme }) => theme.colors['Level 1']);






export const PrimaryButton = /*#__PURE__*/styled(Button).withConfig({ displayName: "styles__PrimaryButton", componentId: "sc-1596n1o-8" })([""]);